
findParent = (element, names=["dybSubForm", "dybFormArray", "dybFormSortable", "dybForm"]) ->
    parent = element.parent()
    for name in names
        controller = parent.controller(name)
        if controller? then return controller
    return null


class dybSubFormController
    @::directiveName = 'dybSubForm'

    ### @ngInject ###
    constructor: ($scope, $element, $attrs, $parse) ->

        @ngForm = $element.controller('form')
        @dybForm = $element.controller('dybForm')
        @parent = findParent($element)
        @parent.addControl(@)

        @controls = {}
        @formData = @formData or @getEmptyFormData()

        if $attrs[@directiveName]
            exp = $parse($attrs[@directiveName])
            exp.assign($scope.$parent, @)

        $scope.$on('$destroy', @$destroy)


    Object.defineProperties @prototype,
        name: get: -> @ngForm.$name
        formData:
            get: -> @parent.getFormData(@)
            set: (value) ->
                @parent.setFormData(@, value)
                return

    getEmptyFormData: ->
        data = {}
        if @subFormId then data['id'] = @subFormId
        return data

    $destroy: =>
        @parent.removeControl(@)
        return

    addControl: (control) ->
        @controls[control.name] = control
        @[control.name] = control
        return

    removeControl: (control) ->
        delete @controls[control.name]
        delete @[control.name]
        return

    getFormData: (control) ->
        return @formData?[control.name]

    setFormData: (control, value) ->
        @formData[control.name] = value
        return

    refreshData: ->
        @formData = @getEmptyFormData()
        control.refreshData() for own name, control of @controls
        return


class dybFormArrayController extends dybSubFormController
    @::directiveName = 'dybFormArray'

    ### @ngInject ###
    constructor: ($scope, $element, $attrs, $parse) ->
        super($scope, $element, $attrs, $parse)
        @controls = []
        @scope = $scope

        @deletedItems = []
        @createdItems = []
        @items = []

        $scope.$watchCollection("viewArray", @rebuildItemArray)

    getEmptyFormData: -> []

    rebuildItemArray: =>
        @items = []
        @items.push item for item in @scope.viewArray when item not in @deletedItems
        @items.push item for item in @createdItems
        return

    addControl: (control) ->
        control._nestedIndex = @controls.length
        @controls.push control
        return

    removeControl: (control) ->
        index = @controls.indexOf control
        if index >= 0
            @controls.splice(index, 1)
            @formData.splice(index, 1)
        @reindex()
        return

    reindex: ->
        item._nestedIndex = i for item, i in @controls
        return

    getFormData: (control) ->
        return @formData?[control._nestedIndex]

    setFormData: (control, value) ->
        @formData[control._nestedIndex] = value
        return

    refreshData: ->
        @deletedItems = []
        @createdItems = []
        @rebuildItemArray()
        @formData = @getEmptyFormData()
        control.refreshData() for control in @controls
        return

    add: (item) ->
        @createdItems.push item
        @rebuildItemArray()
        return

    openAndAdd: (item) ->
        if @dybForm.isOpen then return @add(item)
        return @dybForm.open().then(=> @add(item))

    delete: (item) ->
        index = @createdItems.indexOf item
        if index >= 0 then @createdItems.splice(index, 1)
        else if item not in @deletedItems then @deletedItems.push item
        @rebuildItemArray()
        return

class dybFormSortableController extends dybFormArrayController
    @::directiveName = 'dybFormSortable'

    ### @ngInject ###
    constructor: ($scope, $element, $attrs, $parse) ->
        super($scope, $element, $attrs, $parse)
        @weightName = $attrs.weightAttribute || 'weight'

    rebuildItemArray: ->
        super()
        @sortItems()

    getSortValue: (item) =>
        data = @formData.findId(item.id)
        if data then return data[@weightName]
        else return item[@weightName]

    sortPredicate: (a, b) =>
        a = @getSortValue(a)
        b = @getSortValue(b)
        +(a > b) or +(a == b) - 1

    sortItems: ->
        @items.sort(@sortPredicate)
        @formData.sort(@sortPredicate)
        for control in @controls
            item = @items.findId(control.subFormId)
            index = @items.indexOf(item)
            control._nestedIndex = index

    moveUp: (item) =>
        data = @formData.findId(item.id)
        index = @formData.indexOf(data)
        @swap(index, index - 1)

    moveDown: (item) =>
        data = @formData.findId(item.id)
        index = @formData.indexOf(data)
        @swap(index, index + 1)

    swap: (fromIndex, toIndex) =>
        if toIndex >= 0 and toIndex < @formData.length
            cached = @formData[toIndex][@weightName]
            @formData[toIndex][@weightName] = @formData[fromIndex][@weightName]
            @formData[fromIndex][@weightName] = cached
            @sortItems()
        return

    setFormData: (control, value) ->
        super(control, value)
        item = @items.findId(value.id)
        if item then value[@weightName] = item[@weightName]
        return

    refreshData: ->
        super()
        for control in @controls
            id = control.formData.id
            item = @items.findId(id)
            if item then control.formData[@weightName] = item[@weightName]
        @sortItems()

module.directive('dybSubForm', ->
    restrict: 'A'
    controllerAs: 'ctrl'
    controller: dybSubFormController
    require: ['^^dybForm', 'ngForm']
    priority: -1
    scope: {}
    bindToController:
        subFormId: '=dybSubFormId'
)

module.directive('dybFormArray', ->
    restrict: 'A'
    controllerAs: 'ctrl'
    controller: dybFormArrayController
    require: ['^^dybForm', 'ngForm']
    priority: -1
    scope:
        viewArray: '=array'
)

module.directive('dybFormSortable', ->
    restrict: 'A'
    controllerAs: 'ctrl'
    controller: dybFormSortableController
    require: ['^^dybForm', 'ngForm']
    priority: -1
    scope:
        viewArray: '=array'
)